import { HayabanOsoban } from "@/types/Shinsei";
import { ref, computed } from "vue";
import { HayabanOsobanService } from "@/service/HayabanOsobanService"
import { DialogService } from "@/service/DialogService";

export function useDelete() {
  const srv = new HayabanOsobanService()

  const torikeshi = async(params: HayabanOsoban, koyouKeiyakuTimeId: number) => {
    const res = await srv.delete(params, koyouKeiyakuTimeId).then(res => {
      return res
    })
    return res
  }

  return {
    hayabanOsobanDelete: torikeshi,

  }
}
